module.exports = __webpack_public_path__ + "img/icon-panel-open.b8851cf1.svg";